import React, { useState } from 'react';
import { Divider, Grid } from '@material-ui/core';
import { Colors, PrimaryButton, Text } from 'library';
import { JobModel } from '../NewsfeedModels';
import { useUserContext } from 'UserContext';
import { track } from 'shared/Tracking';

const JobCardActions = ({ job }: { job: JobModel }) => {
    const [detailsExpanded, setDetailsExpanded] = useState(false);
    const { user } = useUserContext();

    const expandDetails = () => {
        track('Job Post Details Toggled', { previousState: detailsExpanded, nextState: !detailsExpanded, job });
        setDetailsExpanded(!detailsExpanded);
    };

    return user?.id !== job.family.user.id ? (
        <>
            <Grid container direction="row" justify="flex-end">
                <PrimaryButton buttonStyle={{ width: 200 }} onClick={expandDetails}>
                    {detailsExpanded ? 'View Less' : 'View More'}
                </PrimaryButton>
            </Grid>
            {detailsExpanded && (
                <Grid
                    container
                    direction="column"
                    style={{ backgroundColor: Colors.lightGrey, padding: 10, marginTop: 10 }}
                >
                    <Text bold variant="body1">
                        Job Description
                    </Text>
                    <Text variant="deprecatedCaption">{job.comments}</Text>
                    <Divider style={{ marginBottom: 10 }} />
                    <Text bold variant="body1">
                        Family Bio
                    </Text>
                    <Text variant="deprecatedCaption">{job.family.bio}</Text>
                </Grid>
            )}
        </>
    ) : null;
};

export default JobCardActions;
